import { createFileRoute } from '@tanstack/react-router'
import { RegisterSuratKeluarPanel } from '../../../../components/register-surat/RegisterSuratKeluarPanel'

export const Route = createFileRoute('/desa/$slug/dashboard/register-surat')({
  component: () => {
    const { desaId } = Route.useRouteContext() as { desaId?: string | null }
    if (!desaId) return null
    return <RegisterSuratKeluarPanel desaId={desaId} />
  },
})
